/**
 * COOKIE-BYTE.JS
 */

 import {CookieConsent, CookieCovers, CookieModal} from '../../../vendor/ddm-studio/cookie-byte';

 export default class CookieByte {
 
	 static init() {
		 return new CookieByte();
	 }
 
	 constructor() {
		 window.CookieConsent = new CookieConsent();
		 window.CookieModal = new CookieModal(window.CookieConsent);
		 window.CookieCovers = new CookieCovers(window.CookieConsent);
	 }
 }